import { ym } from "./lib/ym";

let paramsSent = false;

export function getGameReviewBucket() {
  try {
    // Get existing bucket
    let existing = localStorage.getItem("ab_game_review");

    // If not set, assign once
    if (!existing) {
      existing = Math.random() < 0.25 ? "1" : "0"; // 10% variant
      localStorage.setItem("ab_game_review", existing);
    }

    // ALWAYS send bucket for current session
    if (!paramsSent) {
      const METRIKA_TAG_ID = 103551128; // Keep in sync with _app.tsx
      ym(METRIKA_TAG_ID, "userParams", {
        ab_game_review: existing,
      });
      paramsSent = true;
    }

    return existing === "1";
  } catch (e) {
    return false;
  }
}
